import { render, staticRenderFns } from "./add-providers-to-batch.vue?vue&type=template&id=75e8dfec&"
import script from "./add-providers-to-batch.vue?vue&type=script&lang=js&"
export * from "./add-providers-to-batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports